import React from "react";

import { MemberAvatar } from "@common/memberAvatar";
import { ResourceTypes } from "@planzone/dto";
import { Props } from "./types";
import { VirtualResourceIcon } from "./virtualResourceIcon";
import { MaterialResourceIcon } from "./materialResourceIcon";
import styles from "./styles.scss";

function ResourceAvatar({ resource }: Props) {
  return resource.type === ResourceTypes.HUMAN ? (
    <MemberAvatar avatarUrl={resource.avatarUrl} name={resource.name} />
  ) : resource.type === ResourceTypes.VIRTUAL ? (
    <VirtualResourceIcon className={styles.virtualResourceAvatar} />
  ) : (
    <MaterialResourceIcon className={styles.resourceAvatar} />
  );
}

export { ResourceAvatar };
